import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { PbbImgErrorDirective } from '@core/directives/pbb-img-error.directive';
import { TranslateModule } from '@ngx-translate/core';
import { FinancialInstitution, LoaderState } from '@store/core/core.interface';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NoticeBannerComponent } from '../notice-banner/notice-banner.component';
import {PbbSpinnerComponent} from '../pbb-spinner/pbb-spinner.component';

@Component({
  selector: 'pbb-fi-selection',
  templateUrl: './fi-selection.component.html',
  styleUrls: ['./fi-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatListModule,
    MatButtonModule,
    PbbImgErrorDirective,
    NgxSkeletonLoaderModule,
    TranslateModule,
    NoticeBannerComponent,
    PbbSpinnerComponent
  ],
})
export class FiSelectionComponent implements OnChanges {
  @Output() fiSelected: EventEmitter<FinancialInstitution> = new EventEmitter();
  @Input() financialInstitutions!: LoaderState<FinancialInstitution[]>;
  @Input() linkedFIIds: string[] = [];
  unhealthyFI: boolean = false;

  ngOnChanges(): void {
    this.unhealthyFI = !!this.financialInstitutions.data?.some((fi: FinancialInstitution) => !fi.health_status);
  }

  isLinked(institution: FinancialInstitution): boolean {
    return this.linkedFIIds.includes(institution.id || '');
  }
}
